import { createFileRoute } from '@tanstack/react-router'
import { UserCircle } from 'lucide-react'

import { PlaceholderPage } from '@/components/placeholder-page'

export const Route = createFileRoute('/profile')({
  component: () => (
    <PlaceholderPage
      icon={UserCircle}
      title="Profile"
      description="Update your account details, preferences, and notification settings here."
    />
  ),
})
